import { Button, Heading, Spacer, Video } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export interface ArchivedVideoPlaceholderProps {
  onUpload: () => void;
}

const ArchivedVideoPlaceholder: React.FC<ArchivedVideoPlaceholderProps> = ({
  onUpload,
}) => {
  return (
    <Spacer
      space="16px"
      orientation="vertical"
      align="center"
      justify="center"
      className={block('archived-video-placeholder')}
    >
      <Video
        width={40}
        height={26}
        color="#90A0C0"
        className={block('placeholder-icon')}
      />

      <Heading level={4} className={block('placeholder-heading')}>
        This video has been archived.
        <br />
        Please re-upload it.
      </Heading>

      <Button size="small" onPress={onUpload}>
        Upload video
      </Button>
    </Spacer>
  );
};

export default ArchivedVideoPlaceholder;
